import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/admin-img/image-icon.svg'
import _imports_1 from '@/assets/images/admin-img/upload-icon.svg'
import _imports_2 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "admin-search-box" }
const _hoisted_13 = { class: "admin-add-btn" }
const _hoisted_14 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_15 = { class: "tags" }
const _hoisted_16 = { class: "delete-all-btn-link" }
const _hoisted_17 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_18 = { class: "add-banner-image-section" }
const _hoisted_19 = { class: "add-banner-image-box" }
const _hoisted_20 = { class: "admin-input-field" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_23 = { class: "admin-input-field" }
const _hoisted_24 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_25 = { class: "admin-input-field" }
const _hoisted_26 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_27 = { class: "admin-input-field" }
const _hoisted_28 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_29 = { class: "admin-input-field" }
const _hoisted_30 = { class: "image-upload-input upload-banner-image" }
const _hoisted_31 = { class: "file-input-box" }
const _hoisted_32 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_33 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_36 = { class: "admin-input-field" }
const _hoisted_37 = { class: "image-upload-input upload-icon-image" }
const _hoisted_38 = { class: "file-input-box" }
const _hoisted_39 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_40 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_43 = { class: "admin-input-field-submit" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_46 = { class: "admin-item-list-section-scroll" }
const _hoisted_47 = { class: "admin-item-list-top" }
const _hoisted_48 = { class: "admin-item-list-row" }
const _hoisted_49 = { class: "admin-item-checkbox" }
const _hoisted_50 = { class: "admin-checkbox-input" }
const _hoisted_51 = ["checked"]
const _hoisted_52 = { class: "admin-item-image" }
const _hoisted_53 = { class: "admin-item-icon" }
const _hoisted_54 = { class: "admin-item-actions" }
const _hoisted_55 = { class: "admin-item-list-btm" }
const _hoisted_56 = { ref: "sortableList" }
const _hoisted_57 = { class: "admin-item-box-top" }
const _hoisted_58 = { class: "admin-item-list-row" }
const _hoisted_59 = { class: "admin-item-checkbox" }
const _hoisted_60 = { class: "admin-checkbox-input" }
const _hoisted_61 = ["id", "onChange", "checked"]
const _hoisted_62 = ["for"]
const _hoisted_63 = { class: "admin-item-image" }
const _hoisted_64 = { class: "sm-img" }
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "admin-item-sm-title text-limit" }
const _hoisted_67 = { class: "admin-item-selected-page text-limit" }
const _hoisted_68 = { class: "admin-item-sort-desc text-limit" }
const _hoisted_69 = { class: "admin-item-sm-desc text-limit" }
const _hoisted_70 = { class: "admin-item-icon" }
const _hoisted_71 = { class: "uploaded-icon-sm" }
const _hoisted_72 = ["src"]
const _hoisted_73 = { class: "admin-item-actions" }
const _hoisted_74 = { class: "admin-action-link" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 0,
  class: "admin-item-box-btm"
}
const _hoisted_80 = { class: "add-banner-image-section" }
const _hoisted_81 = { class: "add-banner-image-box" }
const _hoisted_82 = { class: "admin-input-field" }
const _hoisted_83 = ["value"]
const _hoisted_84 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_85 = { class: "admin-input-field" }
const _hoisted_86 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_87 = { class: "admin-input-field" }
const _hoisted_88 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_89 = { class: "admin-input-field" }
const _hoisted_90 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_91 = { class: "admin-input-field" }
const _hoisted_92 = { class: "image-upload-input upload-banner-image" }
const _hoisted_93 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_94 = { class: "file-input-box" }
const _hoisted_95 = { class: "image-upload-input-item-uploaded" }
const _hoisted_96 = ["src"]
const _hoisted_97 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_98 = { class: "admin-input-field" }
const _hoisted_99 = { class: "image-upload-input upload-icon-image" }
const _hoisted_100 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_101 = { class: "file-input-box" }
const _hoisted_102 = { class: "image-upload-input-item-uploaded" }
const _hoisted_103 = ["src"]
const _hoisted_104 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_105 = { class: "admin-input-field-submit" }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = { class: "admin-pagination-section" }
const _hoisted_108 = { class: "custom-row" }
const _hoisted_109 = { class: "item-show-selectbox" }
const _hoisted_110 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { key: 2 }
const _hoisted_113 = { class: "admin-site-footer" }
const _hoisted_114 = { class: "container" }
const _hoisted_115 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_116 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_117 = { class: "modal-content" }
const _hoisted_118 = { class: "confirmation-popup-mid" }
const _hoisted_119 = { class: "confirmation-popup-btm" }
const _hoisted_120 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_SERVICES_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "publishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'published' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('published')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.published), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "unPublishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'unpublished' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('unpublished')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.UNPUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.unpublished), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachServicesInput",
                        type: "text",
                        placeholder: "Search Services",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.fetchServices(_ctx.activeTab), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        id: "addServicesBtn",
                        class: _normalizeClass(["add-btn-admin", { 'active': _ctx.showAddForm }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddForm = true, _ctx.selectedServices = [], _ctx.selectAll = false, _ctx.cancelEdit() ))
                      }, [
                        _cache[37] || (_cache[37] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_SERVICE_BUTTON), 1)
                      ], 2)
                    ])
                  ]),
                  (_ctx.selectedServices.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedServices.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedServices = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.showAddForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_SERVICE_TEXT), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("form", {
                        id: "addServicesForm",
                        onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SELECT_PAGE_LABEL), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "servicesPgSelectPageSelectBox",
                            class: "admin-selectbox",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newService.selectedPage) = $event))
                          }, [
                            _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "Select Page", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageChoices, (value, key) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: key,
                                value: value
                              }, _toDisplayString(key), 9, _hoisted_21))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.newService.selectedPage]
                          ]),
                          (_ctx.formSubmitted && !_ctx.newService.selectedPage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "servicesPgTitleInput",
                            type: "text",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newService.title) = $event)),
                            placeholder: "Enter the Title"
                          }, null, 512), [
                            [_vModelText, _ctx.newService.title]
                          ]),
                          (_ctx.formSubmitted && !_ctx.newService.title)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUB_HEADING_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Sub Heading",
                            class: "text-editer",
                            id: "servicesPgSubHdInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newService.shortDescription,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newService.shortDescription) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (_ctx.formSubmitted && !_ctx.newService.shortDescription)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Description",
                            class: "text-editer",
                            id: "servicesPgDescInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newService.description,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newService.description) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (_ctx.formSubmitted && !_ctx.newService.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SERVICE_IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", {
                              class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.imageUploaded }])
                            }, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("button", {
                                  class: "image-upload-input-item-delete-btn",
                                  id: "uploaded-img-delete-btn",
                                  type: "button",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearUploadedImage(false, 'service-image')))
                                }),
                                _createElementVNode("input", {
                                  id: "addServicesPgFileInput",
                                  type: "file",
                                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleFileUpload($event, false))),
                                  accept: "image/jpeg,image/jpg,image/png"
                                }, null, 32)
                              ]),
                              (!_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                      _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: ""
                                      })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_IMAGE_LABEL), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("img", {
                                      src: _ctx.imageUrl,
                                      alt: "",
                                      class: "mCS_img_loaded"
                                    }, null, 8, _hoisted_34)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          (_ctx.formSubmitted && !_ctx.selectedFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SERVICE_ICON_LABEL), 1),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", {
                              class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.iconUploaded }])
                            }, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("button", {
                                  class: "image-upload-input-item-delete-btn",
                                  id: "uploaded-img-delete-btn",
                                  type: "button",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearUploadedImage(false, 'service-icon')))
                                }),
                                _createElementVNode("input", {
                                  id: "addServicesPgIconFileInput",
                                  type: "file",
                                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleIconUpload($event, false))),
                                  accept: "image/jpeg,image/jpg,image/png"
                                }, null, 32)
                              ]),
                              (!_ctx.iconUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: ""
                                      })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.UPLOAD_ICON_LABEL), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.iconUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createElementVNode("img", {
                                      src: _ctx.iconUrl,
                                      alt: "",
                                      class: "mCS_img_loaded"
                                    }, null, 8, _hoisted_41)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          (_ctx.formSubmitted && !_ctx.selectedIconFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("button", {
                            id: "servicesPgSubmitBtn",
                            type: "submit",
                            class: "admin-btn-outline-primary add-new-cancel",
                            disabled: _ctx.isSubmitting
                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_44),
                          _createElementVNode("button", {
                            id: "servicesPgSubmitBtn",
                            type: "button",
                            class: "admin-btn-outline-secondary add-new-cancel",
                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                        ])
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editServicesData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['admin-item-list-section admin-services-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_51),
                              _cache[41] || (_cache[41] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", {
                            class: "admin-item-sm-title",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toggleSort('title'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.TITLE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'title' || _ctx.sortBy === '-title')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-title' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-selected-page",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toggleSort('selectedPage'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.SELECTED_PAGE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'selectedPage' || _ctx.sortBy === '-selectedPage')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-selectedPage' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-sort-desc",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleSort('shortDescription'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.SUB_HEADING_LABEL) + " ", 1),
                            (_ctx.sortBy === 'shortDescription' || _ctx.sortBy === '-shortDescription')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-shortDescription' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-sm-desc",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleSort('description'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DESCRIPTION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'description' || _ctx.sortBy === '-description')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-description' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.constants.ICON_LABEL), 1),
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1),
                          _cache[42] || (_cache[42] = _createElementVNode("div", { class: "clear" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editServicesData, (service, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: service.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': service.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + service.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleServiceSelection(service.id)),
                                        checked: _ctx.selectedServices.includes(service.id)
                                      }, null, 40, _hoisted_61),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + service.id
                                      }, null, 8, _hoisted_62)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(service.serviceImage, `w_40,h_41/`) || '@/assets/images/admin-img/demo-img/item-img-6.jpg',
                                        alt: ""
                                      }, null, 8, _hoisted_65)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(service.title), 1),
                                  _createElementVNode("div", _hoisted_67, _toDisplayString(service.selectedPage), 1),
                                  _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.useStripHtml(service.shortDescription)), 1),
                                  _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.useStripHtml(service.description)), 1),
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(service.serviceIcon, `w_21,h_23/`) || '@/assets/images/admin-img/demo-img/demo-icon-1.png',
                                        alt: ""
                                      }, null, 8, _hoisted_72)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    _createElementVNode("ul", _hoisted_74, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "servicePgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editService(index), _ctx.showAddForm = false)
                                        }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_75)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "servicePgDeleteBtn",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', service.id), _ctx.showAddForm = false, _ctx.cancelEdit())
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_76)
                                      ]),
                                      _createElementVNode("li", null, [
                                        (service.status === 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              id: "servicePgUnPublishBtn",
                                              class: "primary-outline-btn",
                                              onClick: ($event: any) => (_ctx.changeServiceStatus(service.id, 0))
                                            }, _toDisplayString(_ctx.constants.UNPUBLISH_BUTTON), 9, _hoisted_77))
                                          : (service.status === 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                id: "servicePgPublishBtn",
                                                class: "primary-outline-btn",
                                                onClick: ($event: any) => (_ctx.changeServiceStatus(service.id, 1))
                                              }, _toDisplayString(_ctx.constants.PUBLISH_BUTTON), 9, _hoisted_78))
                                            : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "clear" }, null, -1))
                                ])
                              ]),
                              (service.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                    _createElementVNode("div", _hoisted_80, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_SERVICE_TEXT), 1),
                                      _createElementVNode("div", _hoisted_81, [
                                        _createElementVNode("div", _hoisted_82, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SELECT_PAGE_LABEL), 1),
                                          _withDirectives(_createElementVNode("select", {
                                            id: "servicesPgSelectPageSelectBox",
                                            class: "admin-selectbox",
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editServiceData.selectedPage) = $event))
                                          }, [
                                            _cache[44] || (_cache[44] = _createElementVNode("option", { value: "" }, "Select Page", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageChoices, (value, key) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: key,
                                                value: value
                                              }, _toDisplayString(key), 9, _hoisted_83))
                                            }), 128))
                                          ], 512), [
                                            [_vModelSelect, _ctx.editServiceData.selectedPage]
                                          ]),
                                          (!_ctx.editServiceData.selectedPage)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_85, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "servicesPgTitleInput",
                                            type: "text",
                                            placeholder: "Enter the Title",
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editServiceData.title) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editServiceData.title]
                                          ]),
                                          (!_ctx.editServiceData.title)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_87, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUB_HEADING_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Description",
                                            class: "text-editer",
                                            id: "servicesPgSubHdInput",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editServiceData.shortDescription,
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.editServiceData.shortDescription) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editServiceData.shortDescription)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_89, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Description",
                                            class: "text-editer",
                                            id: "servicesPgDescInput",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editServiceData.description,
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editServiceData.description) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editServiceData.description)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_91, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SERVICE_IMAGE_LABEL), 1),
                                          _createElementVNode("div", _hoisted_92, [
                                            _createElementVNode("div", _hoisted_93, [
                                              _createElementVNode("div", _hoisted_94, [
                                                _createElementVNode("button", {
                                                  class: "image-upload-input-item-delete-btn",
                                                  id: "uploaded-img-delete-btn",
                                                  type: "button",
                                                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.clearUploadedImage(true, 'service-image')))
                                                }),
                                                _createElementVNode("input", {
                                                  id: "editServicesPgFileInput",
                                                  type: "file",
                                                  onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleFileUpload($event, true))),
                                                  accept: "image/jpeg,image/jpg,image/png"
                                                }, null, 32)
                                              ]),
                                              _createElementVNode("div", _hoisted_95, [
                                                _createElementVNode("img", {
                                                  src: _ctx.editimageSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                  alt: ""
                                                }, null, 8, _hoisted_96)
                                              ])
                                            ])
                                          ]),
                                          (!_ctx.selectedFile && !_ctx.editimageSrc)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_98, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SERVICE_ICON_LABEL), 1),
                                          _createElementVNode("div", _hoisted_99, [
                                            _createElementVNode("div", _hoisted_100, [
                                              _createElementVNode("div", _hoisted_101, [
                                                _createElementVNode("button", {
                                                  class: "image-upload-input-item-delete-btn",
                                                  id: "uploaded-img-delete-btn",
                                                  type: "button",
                                                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.clearUploadedImage(true, 'service-icon')))
                                                }),
                                                _createElementVNode("input", {
                                                  id: "editServicesPgIconFileInput",
                                                  type: "file",
                                                  onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleIconUpload($event, true))),
                                                  accept: "image/jpeg,image/jpg,image/png"
                                                }, null, 32)
                                              ]),
                                              _createElementVNode("div", _hoisted_102, [
                                                _createElementVNode("img", {
                                                  src: _ctx.editIconSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                  alt: ""
                                                }, null, 8, _hoisted_103)
                                              ])
                                            ])
                                          ]),
                                          (!_ctx.selectedEditIconFile && !_ctx.editIconSrc)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_105, [
                                          _createElementVNode("button", {
                                            id: "servicesPgSubmitBtn",
                                            class: "admin-btn-outline-primary",
                                            onClick: ($event: any) => (_ctx.submitEditForm(service.id))
                                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_106),
                                          _createElementVNode("button", {
                                            id: "servicesPgSubmitBtn",
                                            class: "admin-btn-outline-secondary addNewCancel",
                                            onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[45] || (_cache[45] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[46] || (_cache[46] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_111))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[47] || (_cache[47] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_112, [...(_cache[48] || (_cache[48] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_113, [
      _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_115, [
      _createElementVNode("div", _hoisted_116, [
        _createElementVNode("div", _hoisted_117, [
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_119, [
            _createElementVNode("button", _hoisted_120, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}